import React, { useEffect, useState } from 'react'
import MUIDataTable from 'mui-datatables';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Button } from 'react-bootstrap';
import { alertResponseYesNo, alertTime, deleteFile } from '../../../functions/helperFunctions';
import { deleteClients, getClients } from '../../../services/apiClient';
import ClientDialog from '../../Dialogs/ClientDialog';


function ClientsA() {

  const [clients, setClients] = useState([]);
  const [show, setShow] = useState(false);
  const [data, setData] = useState(null);

  const columns = [
    { name: "nombre", label: "Nombre", options: { filter: true, sort: true, } },
    { name: "telefono", label: "telefono" },
    { name: "fecha", label: "cumpleaños", options: { customBodyRender: (value) => (<p> {value} </p>) } },
    { name: "servicio", label: "N°" },
    { name: "descripcion", label: "descripción" },
    {
      name: "acciones",
      label: "ACCIÓN",
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRenderLite: (value) => {
          return (
            <>
              <Button variant="warning" onClick={() => openDialog(clients[value])} >
                <i className='fa-solid fa-edit'  ></i>
              </Button>
              &nbsp;
              <Button variant="danger" >
                <i className='fa-solid fa-trash' onClick={() => deleteData(clients[value])}  ></i>
              </Button>
            </>
          );
        },
      },
    },
  ];


  const handleClose = (action) => {
    setShow(false)
    if (action === 'accept') {
      getData()
    }
  };


  const openDialog = (data) => {
    setShow(true)
    setData(data)
  }

  const deleteData = async (data) => {

    const response = await alertResponseYesNo('Advertencia', '¿Está seguro de que desea eliminar un cliente?', 'question');

    if (response.isConfirmed) {
      try {
        const deleteResponse = await deleteClients(data.id);
        await deleteFile(data.foto)
        if (deleteResponse.statusText === "OK") {
          alertTime('OK', 'Cliente eliminado con éxito', 'success')
          getData()
        } else {
          alert('Error', 'Intente de nuevo', 'error');
        }
      } catch (error) {
        console.error('Error al eliminar la cliente:', error);
        alert('Error', 'Intente de nuevo', 'error');
      }
    }


  }


  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const response = await getClients();
      setClients(response)
    } catch (error) {
      console.log('Error al obtener los servicios : ', error)
    }
  }




  return (
    <>
      <Container>
        <h2>Listado de clientes </h2>
      </Container>
      <Container className='m-3'>
        <Row>
          <Col sm={12} lg={4} >
            <Button className='w-100' onClick={() => openDialog(null)} >
              <i className='fas fa-plus-circle' > </i> Agregar
            </Button>
          </Col >
        </Row>
      </Container>
      <Container>
        <MUIDataTable
          data={clients}
          columns={columns}
          options={{
            selectableRows: "none",
            download: false,
            viewColumns: false,
            responsive: 'standard',
            elevation: 5,
            rowsPerPage: 5,
            rowsPerPageOptions: [5, 10, 20]
          }}
        />
      </Container>
      <ClientDialog show={show} handleClose={handleClose} data={data} />
    </>
  )
}

export default ClientsA